<template>
    <div>
        <AppHeader/>
        <v-form class="ma-5">
            <v-container>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="8">
                        <div class="video-container">
                            <iframe
                                    class="video"
                                    src="https://www.youtube.com/embed/V407RIunoyU"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                            ></iframe>
                        </div>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                        <div class="backgroundColor1">
                            <v-card-title>Zusätzliche Materialien</v-card-title>
                            <v-card-text>
                                <span>
                                    <a href="ttps://blog.enra.app/digitalisierung-vertrieb/" target="_blank">Blog:</a> Herausforderungen im Prozess zum Sales 4.0
                                </span> <br>
                                <span>
                                    <a href="./../static/thesenpapier_umsetzung_digitalisierung_vertieb-anwendungsbereiche_gestalten.pdf" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                                </span>
                            </v-card-text>
                        </div>

                    </v-col>
                </v-row>
                <v-row class="mt-5 backgroundColor1">
                    <v-col>
                        <v-card-title>Einführung in Sales 4.0 - die Zukunft des B2B-Vertriebs</v-card-title>
                        <v-card-text>
                            Der Zugang zum Thema Sales 4.0 erscheint häufig schwierig – besonders für kleine und
                            mittlere Unternehmen. Unternehmen wissen um die Chancen hinter digitalisierten
                            Vertriebsstrukturen und Vertriebsaktivitäten, doch wie gelingt der Start?
                            Im ersten Modul geht es genau darum: eine einheitliche Grundlage schaffen. Begriffe
                            definieren, die Entstehung von Sales 4.0 kennenlernen und mögliche Vorteile für das eigene
                            Unternehmen evaluieren.
                        </v-card-text>
                        <v-card-actions>
                            <router-link to="/" class="text-decoration-none">
                                <v-btn color="third" class="white--text mt-3">zur Übersicht</v-btn>
                            </router-link>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import AppHeader from "./AppHeader";

    export default {
        components: {
            AppHeader,
        },
        data() {
            return {};
        },
    };
</script>

<style scoped>
    .backgroundColor1 {
        background-color: #f7f7f7;
        height: 100%;
        padding: 1em;
    }

    .video-container {
        position: relative;
        padding-bottom: 56.25%;
        padding-top: 0;
        height: 0;
        overflow: hidden;

    }

    .video-container iframe,
    .video-container object,
    .video-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>